<template>
  <div v-if="state" class="ais-GeoSearch">
    <googlemaps-map
      ref="propertiesMap"
      :center="center"
      :zoom.sync="zoom"
      class="ais-GeoSearch-map"
    >
      <googlemaps-marker
        v-for="item of state.items"
        :ref="item.objectID"
        :key="item.objectID"
        :position="item._geoloc"
        @click="selectMarker(item)"
      />
    </googlemaps-map>
  </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectGeoSearch } from 'instantsearch.js/es/connectors';

export default {
  mixins: [createWidgetMixin({ connector: connectGeoSearch })],
  data() {
    return {
      zoom: 11,
    };
  },
  computed: {
    center() {
      return this.state.items.length !== 0
        ? this.state.items[0]._geoloc
        : { lat: 54.227962, lng: -4.549713 };
    },
  },
  methods: {
    selectMarker(marker) {
      const map = this.$refs.propertiesMap.$_map;
      const marker_ele = this.$refs[marker.objectID][0].$_marker;
      let contentString = '';
      if (marker.houseName) {
        contentString += `${marker.houseName}, `;
      }

      contentString += `${marker.houseNumber} ${marker.streetName}, ${marker.postcode}`;

      // eslint-disable-next-line no-undef
      const infowindow = new google.maps.InfoWindow({
        content: contentString,
      });

      infowindow.open(map, marker_ele);

      const selector = `#result-${marker.id}`;
      // TODO: figure out how this will work if result not shown on current page
      this.$scrollTo(selector, 300, {
        onDone: function(element) {
          element.classList.add('animated', 'flash');
        },
      });
    },
  },
};
</script>

<style>
.ais-GeoSearch {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.ais-GeoSearch-map {
  flex: 100% 1 1;
}
</style>
